const React = require("react")
import "./src/scss/global.scss"